
import { lazy } from "react";
import { settingSVG, flagSVG } from "../shared/helpers/icons";

const EntryPoint = lazy(() => import(/* webpackChunkName: "settings" */ './components/EntryPoint'));
const StatusesLoader = lazy(() => import(/* webpackChunkName: "statusesLoader" */ './components/StatusesLoader'));

export const defaultPath = "/settings";

export const innerRoutes = [
    {
        path: `${defaultPath}/statuses`,
        Component: StatusesLoader,
        exact: true,
        icon: flagSVG,
        title: {
            key: "statuses",
            plural: false
        },
        subTitle: {
            key: "statuses_list",
            plural: false
        }
    }
];

const Settings = {
    path: defaultPath,
    Component: EntryPoint,
    exact: false,
    icon: settingSVG,
    title: {
        key: "settings",
        plural: false
    },
    subTitle: {
        key: " ",
        plural: false
    },
    innerRoutes: [...innerRoutes],
    availableSubMenu: true,
    pathChilds: innerRoutes.map(e => e.path)
};

export default Settings;
